import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PageTitle from "./PageTitleCompoent";
import "../css/AddPackage.css";
import api from "../api"; // ✅ Centralized API instance
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const tagMap = {
  Popular: "popular",
  "Great Deals": "great_deals",
  "Steal Deals": "steal_deals",
};

export default function AddWalkingPackage() {
  const navigate = useNavigate();

  const [packageName, setPackageName] = useState("");
  const [duration, setDuration] = useState("");
  const [amount, setAmount] = useState("");
  const [subscribedAmount, setSubscribedAmount] = useState("");
  const [promoTag, setPromoTag] = useState("");

  const handleSave = async () => {
    // --- Validations ---
    if (!packageName.trim()) {
      toast.error("Please enter package name");
      return;
    }
    if (!amount || !subscribedAmount) {
      toast.error("Please enter both amount and subscribed offer price");
      return;
    }

    const newPackage = {
      package_name: packageName.trim(),
      duration: duration.trim(),
      package_amount: parseFloat(amount),
      subscribed_user_offer_amount: parseFloat(subscribedAmount),
      services: "", // walking packages have no services
      tags: promoTag ? tagMap[promoTag] : "",
    };

    try {
      const res = await api.post("/walking-packages/", newPackage);

      const formattedPackage = {
        id: res.data.id,
        title: res.data.package_name,
        duration: res.data.duration,
        subscribedPrice: parseFloat(res.data.subscribed_user_offer_amount),
        unsubscribedPrice: parseFloat(res.data.package_amount),
        tag: res.data.tags,
      };

      toast.success(`Package "${res.data.package_name}" added successfully!`);

      // Navigate back and pass new package
      navigate(-1, { state: { newPackage: formattedPackage } });
    } catch (error) {
      console.error("Error saving walking package:", error);
      toast.error("Failed to save package. Please try again.");
    }
  };

  return (
    <div className="Add-package-container">
      <Sidebar />
      <div className="Add-package-main">
        <Header />
        <div className="Add-package-content">
          <PageTitle title="Add Package" onBack={() => navigate(-1)} />

          <div className="Add-package-grid">
            {/* Package Name & Duration */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Package Name</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={packageName}
                  onChange={(e) => setPackageName(e.target.value)}
                  placeholder="Enter Package Name..."
                  style={{ width: "65%" }}
                />
              </div>
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Duration</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="text"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  placeholder="Enter Duration..."
                  style={{ width: "65%" }}
                />
              </div>
            </div>

            {/* Amount & Subscribed Amount */}
            <div className="Add-package-form-row">
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">Package Amount</h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter Amount..."
                  style={{ width: "65%" }}
                />
              </div>
              <div className="Add-package-form-group1">
                <label>
                  <h3 className="Add-package-text2">
                    Subscribed User Offer Amount
                  </h3>
                </label>
                <input
                  className="Add-package-inputbox"
                  type="number"
                  value={subscribedAmount}
                  onChange={(e) => setSubscribedAmount(e.target.value)}
                  placeholder="Enter Offer Amount..."
                  style={{ width: "65%" }}
                />
              </div>
            </div>

            {/* Promo Tags */}
            <div className="Add-package-form-group1">
              <label>
                <h3 className="Add-package-text2">Tags</h3>
              </label>
              <div className="Add-package-tags-buttons">
                {["Popular", "Great Deals", "Steal Deals"].map((tagOption) => (
                  <button
                    key={tagOption}
                    type="button"
                    className={`Add-package-tag-button ${
                      promoTag === tagOption
                        ? `${tagOption.toLowerCase().replace(/\s+/g, "_")}_selected`
                        : ""
                    }`}
                    onClick={() => setPromoTag(tagOption)}
                  >
                    {tagOption}
                  </button>
                ))}
              </div>
            </div>

            {/* Save Button */}
            <div className="Add-package-button-wrapper">
              <button
                className="Add-package-save-button"
                onClick={handleSave}
                type="button"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
